import { JsonProperty } from "../../../models/utilities/json-property";
import { ValidateProperty } from "../../../models/utilities/validate-property";
import { AssetType } from "../enums/_index";
import { AssetStatus } from "../enums/asset-status";
import { TractorMake } from "../enums/tractor-make";
import { TractorType } from "../enums/tractor-type";
import { TrailerMake } from "../enums/trailer-make";
import { TrailerType } from "../enums/trailer-type";

/**
 * The update Asset class
 */
export class AssetUpdate {

    @ValidateProperty({ required : true })
    public type : AssetType;
    
    @ValidateProperty({ required : true })
    public status           : AssetStatus = -1;
        
    @ValidateProperty({ required : true })
    public name : string = '';

    @ValidateProperty({ required : true })
    public year : number;

    @ValidateProperty({ required : true })
    public axleCount : number;

    public vin : string = '';

    public licensePlateState : string = '';

    public licensePlateNumber : string = '';

    @JsonProperty({ toType: 'date' })
    @ValidateProperty({ required : true })
    public inServiceDate : Date|undefined = undefined;

    @JsonProperty({ toType: 'date' })
    public outOfServiceDate : Date|undefined = undefined;

    @ValidateProperty({ required: true })
    public rowVersion : string = '';

}

        export class TrailerUpdate extends AssetUpdate {

            @ValidateProperty({ required : true })
            public trailerMake : TrailerMake;
            
            @ValidateProperty({ required : true })
            public trailerType : TrailerType;

            constructor() {
                super();
                this.type = AssetType.Trailer;
            }
        }
        
        export class TractorUpdate extends AssetUpdate {

            @ValidateProperty({ required : true })
            public tractorMake : TractorMake;
            
            @ValidateProperty({ required : true })
            public tractorType : TractorType;

            constructor() {
                super();
                this.type = AssetType.Tractor;
            }

        }

        export class BoxTruckUpdate extends AssetUpdate {

            constructor() {
                super();
                this.type = AssetType.BoxTruck;
            }

        }
